<template>
  <b-select 
    :value="status" 
    @change="onChange"
  >
    <b-select-option 
      v-for="(i,index) in statusOpties" 
      :key="index" 
      :value="index"
    >
      {{ i.label }}
    </b-select-option>
  </b-select>
</template>
<script>
export default {
  name: "UnitStatus",
  props: {
    status: { type: Number, default: 0 }
  },

  data() {
    return {
      statusOpties: [
        { label: "Uit contract" },
        { label: "In beheer" },
        { label: "Subbeheer" },
        { label: "Losse inspectie" }
      ]
    };
  },
  methods: {
    onChange(newValue) {
      this.$emit("status-changed", newValue);
      console.dir(newValue);
    }
  },
};
</script>